import { Box, HStack, Text, UseToastOptions } from '@chakra-ui/react';
import { MdClose } from 'react-icons/md';

import { getGlassyEffectContainer } from '@/styles/variants/glassy';

import { IconButton } from '../../core/Button';
import { SnackbarProps } from './Snackbar.types';
import { getNotificationColorConfig, SnackbarIcon } from './SnackbarIcon';

export function SnackbarComponent(
  props: Parameters<NonNullable<UseToastOptions['render']>>[0]
) {
  const snackbarProps = (props.styleConfig || {}) as SnackbarProps;

  const colorConfig = getNotificationColorConfig(snackbarProps.type);

  const glassyStyles = getGlassyEffectContainer(colorConfig);

  const href = snackbarProps.targetUrl;

  return (
    <Box
      __css={glassyStyles}
      width={{ base: 'full', md: '400px' }}
      minHeight='16px'
      position='relative'
      borderRadius='2xl'
      overflow='hidden'
    >
      <Box
        position='absolute'
        inset='0'
        bg='black.300'
        borderRadius='2xl'
        zIndex={0}
      />
      <Box
        as={href ? 'a' : 'div'}
        {...(href
          ? {
              href,
              target: '_blank',
              rel: 'noopener noreferrer',
              cursor: 'pointer',
            }
          : {})}
        _hover={{ textDecoration: 'none' }}
        display='block'
      >
        <HStack
          px='4'
          py='3'
          gap='4'
          alignItems='center'
          position='relative'
          zIndex={1}
        >
          <SnackbarIcon
            type={snackbarProps.type}
            iconOverride={snackbarProps.icon}
          />
          <Box minW='0' flexGrow={1}>
            <Text
              fontSize='sm'
              lineHeight={5}
              fontWeight='semibold'
              paddingRight='20px'
            >
              {snackbarProps.title}
            </Text>
            <Text fontSize='sm' lineHeight={5}>
              {snackbarProps.description}
            </Text>
          </Box>
        </HStack>
      </Box>
      {props.isClosable && (
        <IconButton
          variant='link'
          size='sm'
          onClick={props.onClose}
          top='3'
          right='3'
          position='absolute'
          aria-label='Close'
          width='16px'
          minWidth='16px'
          color='white'
          opacity={0.3}
          _hover={{ opacity: 1 }}
          _active={{ opacity: 1 }}
          _focus={{ opacity: 1 }}
          zIndex={1}
          icon={<MdClose size={16} />}
        />
      )}
    </Box>
  );
}
